import { isSingerOrLiveBandCategory } from '../../../data/membershipPlansData';
import type { JobsTypeFilter } from '../../../stores/jobsGigsStore';

export interface GigsTypeTab {
  id: JobsTypeFilter;
  label: string;
}

const GIGS_TYPE_TAB_LABELS: Record<JobsTypeFilter, string> = {
  express: 'Express',
  standard: 'Standard',
  all: 'All',
};

const SINGER_LIVE_BAND_TAB_ORDER: JobsTypeFilter[] = ['express', 'standard', 'all'];
const DEFAULT_TAB_ORDER: JobsTypeFilter[] = ['standard', 'all'];

export function defaultGigsTypeForCategory(categoryName?: string | null): JobsTypeFilter {
  return isSingerOrLiveBandCategory(categoryName) ? 'express' : 'standard';
}

export function getGigsTypeTabs(categoryName?: string | null): GigsTypeTab[] {
  const order = isSingerOrLiveBandCategory(categoryName)
    ? SINGER_LIVE_BAND_TAB_ORDER
    : DEFAULT_TAB_ORDER;

  return order.map((id) => ({ id, label: GIGS_TYPE_TAB_LABELS[id] }));
}
